import React from 'react';

import { logger } from '../lib/logger';
import ErrorDisplay from '../components/ErrorDisplay/index.js';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    error.meta = { page: this.props.page };
    logger.error(
      error,
      { message: 'Failed to load page component.' },
      errorInfo
    );
  }

  render() {
    if (this.state.hasError) {
      return <ErrorDisplay errors={[this.state.error]} />;
    }

    return this.props.children;
  }
}
